export default {
    root: {},
    input: {
        padding: "10px 6px 10px",
    },
};
